import { Card } from '@braze/web-sdk';

const CARD_SLOT_KEY = 'slot';

/**
 * Filters the list of Braze content cards based on the specified slot.
 *
 * The filter is a comma-delimited string, such as 'dashboard', 'manage-session', or 'timesheet'.
 * If a card does not have a slot (i.e., the 'slot' key is missing or undefined in `card.extras`),
 * or if the slot does not match the filter, the card will be excluded from the result.
 *
 * @param slot - The slot filter to use.
 * @param cards - The Braze content cards to filter.
 * @returns The filtered list of cards that match the specified slot.
 */
export function filterCardsBySlot<C extends Card>(slot: string, cards: C[]): C[] {
  return cards.filter((card: C) => {
    const cardSlots = card.extras?.[CARD_SLOT_KEY];
    if (typeof cardSlots === 'string') {
      return cardSlots.split(',').some((cardSlot) => cardSlot.trim() === slot);
    }

    return false;
  });
}
